<template>
  <div class="page-shell">
    <div class="page-header">
      <div class="page-header__titles">
        <h1 class="page-title">User Information</h1>
        <p class="page-subtitle">Manage registered system users and access</p>
      </div>
      <div class="page-actions">
        <add-user-modal />
      </div>
    </div>

    <div class="content-card">
      <v-data-table :items="users" :headers="user_headers">
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex">
            <v-btn icon small color="warning" @click="show_edit_modal(item)"
              ><v-icon small>mdi-pencil-outline</v-icon></v-btn
            >
            <v-btn icon small color="error" class="ml-1"
              ><v-icon small>mdi-delete-outline</v-icon></v-btn
            >
          </div>
        </template>
      </v-data-table>
    </div>
    <!-- lazy loaded components -->
    <edit-user-modal
      v-if="show_edit"
      :item="selected_item"
      @close_edit="show_edit = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addUserModal from "../components/User/addUserModal.vue";
export default {
  components: {
    addUserModal,
    EditUserModal: () => import("../components/User/editUserModal.vue"),
  },
  created() {
    if (this.users.length <= 0) {
      this.get_users();
    }
  },
  data() {
    return {
      selected_item: [],
      show_edit: false,
      user_headers: [
        { text: "Actions", value: "actions" },
        {
          text: "User ID",
          value: "id",
        },
        { text: "User Name", value: "username" },
        { text: "Access Level", value: "access_level" },
        { text: "Device Limit", value: "device_limit" },

        {
          text: "Created at",
          value: "created_at",
        },
        {
          text: "Updated at",
          value: "updated_at",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      get_users: "user/get_users",
    }),
    show_edit_modal(item) {
      this.selected_item = item;
      this.show_edit = true;
    },
  },
  computed: {
    ...mapGetters({
      users: "user/users",
    }),
  },
};
</script>

<style></style>
